/**
 * Branding configuration — single source of truth for product/client identity.
 *
 * This deployment is one client instance of the BIZNTL OPS line (Computeconnect
 * Innovations LLP). Rebranding for another client must only ever touch this file —
 * no brand strings or logo paths belong in components.
 */
export const BRANDING = {
  /** Product line identity (Option A hero on the login page, powered-by in-app). */
  productName: "BIZNTL OPS",
  productDescriptor: "The Complete Manufacturing Operations System",
  productWordmarkOnDark: "/images/bizntl-white.png",
  productWordmarkOnLight: "/images/bizntl-black.png",
  owner: "Computeconnect Innovations LLP",

  /** Client deployment identity (dominant inside the app — Option C). */
  clientName: "Century Polymers",
  clientLogo: "/images/logo.png",
  clientTagline: "Crafting Excellence in Plastic Moulding",
} as const;

/** Browser-tab title, e.g. "Dashboard — Century Polymers · BIZNTL OPS". */
export function pageTitle(prefix?: string): string {
  const base = `${BRANDING.clientName} · ${BRANDING.productName}`;
  return prefix ? `${prefix} — ${base}` : base;
}
